import React from "react";
import { Menu } from "semantic-ui-react";
import { Link } from "gatsby";
import * as styles from "./app-icon.module.css";
import svg from "./screenpresso-logo.svg";

export const AppIcon = ({ siteTitle, center, locale }) => {
  const style = center !== undefined ? { margin: "0 auto" } : {};
  return (
    <Menu.Item
      as={Link}
      to={`/${locale && locale !== "en" ? locale + "/" : ""}`}
      header
      style={style}
    >
      <img src={svg} className={styles.logo} alt="Screenpresso logo" />{" "}
      {siteTitle}
    </Menu.Item>
  );
};
